module.exports = "mutation($message: String!, $type: String!) {\n    saveTelemetry(message: $message, type: $type)\n}\n"